import React from "react";
import { useAnimateInView } from "./useAnimateInView";
import { TextButton, useIcon } from "@SeemplicityDev/shared";
import PageActions from "../Components/PageActions";

// S3 arn: (dev) arn:aws:s3:::seem-eoy-2024/background.mp4
const BackgroundVideo =
  "https://seem-eoy-2024.s3.eu-central-1.amazonaws.com/background.mp4";

interface FinalPageProps {
  onExit: () => void;
  onMute: () => void;
  isMuted: boolean;
  onDownload: () => void;
}

const FinalPage: React.FC<FinalPageProps> = ({
  onExit,
  onMute,
  isMuted,
  onDownload,
}) => {
  const { ref, animateClassNames } = useAnimateInView();
  const { getSvg } = useIcon("LIGHT");
  return (
    <div className={`eoy-page final-page ${animateClassNames}`} ref={ref}>
      <video autoPlay muted loop playsInline className="bg-video">
        <source src={BackgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="page-actions-container">
        <PageActions
          onMute={onMute}
          onDownload={onDownload}
          onExit={onExit}
          isMuted={isMuted}
        />
      </div>
      <img src={getSvg("logo")} alt="Seemplicity" className="seem-logo" />
      <h1>Your 2025 was Outstanding</h1>
      <div className="subtitle">Seemplicity Magic 2026 is waiting for you</div>
      <TextButton
        label={"Back to Platform"}
        onClick={onExit}
        className="eoy-action-button back-to-platform-button"
      />
      <TextButton
        label={"Download Review"}
        onClick={onDownload}
        className="eoy-action-button-inverted download-review-button"
      />
    </div>
  );
};
export default FinalPage;
